"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var comic_list_1 = __importDefault(require("../comic/comic-list"));
var logo_svg_1 = __importDefault(require("../../assets/images/logo.svg"));
var Home = function (props) {
    return (react_1.default.createElement("div", { className: "home" },
        react_1.default.createElement("div", { className: "home__hero" },
            react_1.default.createElement("div", { className: "home__header" },
                react_1.default.createElement("div", { className: "home__header-content" },
                    react_1.default.createElement("img", { className: "home__header-logo", alt: "Comixtopia", title: "Comixtopia", src: logo_svg_1.default }))),
            react_1.default.createElement("div", { className: "home__hero-content-container" },
                react_1.default.createElement("div", { className: "home__hero-content" },
                    react_1.default.createElement("h1", null, "Hi! Welcome to Comixtopia."),
                    react_1.default.createElement("p", null, "Comixtopia is an indie comic hosting service. It's not currenty open to the public, but if you are looking for a place to host your masterpiece -free of charge-, I'll be glad to help you out."),
                    react_1.default.createElement("p", null,
                        "Feel free to drop me an email! ",
                        react_1.default.createElement("a", { href: "mailto:albertodlh@gmail.com" }, "albertodlh@gmail.com"))))),
        react_1.default.createElement(comic_list_1.default, __assign({}, props)),
        react_1.default.createElement("div", { className: "home__footer" },
            react_1.default.createElement("p", null, "\u00A9 2023 Comixtopia"))));
};
exports.default = Home;
